/* eslint-disable @typescript-eslint/no-explicit-any */
import { Response } from "../api.interface";
import {
  DeleteBrowseHistoryReq,
  GetBrowseHistoryListReq,
  BrowseHistoryRes,
} from "./browsingHistory.interface";
import newColorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";

// 查询用户浏览记录
export const fetchGetBrowseHistoryList = (
  params: GetBrowseHistoryListReq,
): Promise<Response<BrowseHistoryRes>> => {
  console.log("sxt-params", params);
  return newColorAxiosInstance
    .post<Response<BrowseHistoryRes>>("user_history_getList", undefined, { params })
    .then((response: any) => response.data)
    .catch((err: any) => err);
};

// 删除历史记录
export const fetchDeleteBrowseHistory = (
  params: DeleteBrowseHistoryReq,
): Promise<Response<number>> => {
  return newColorAxiosInstance
    .post<Response<number>>("user_history_delete", undefined, { params })
    .then((response: any) => response.data)
    .catch((err: any) => err);
};
